import { render, staticRenderFns } from "./WizardSummary.vue?vue&type=template&id=3ab9e2c0&scoped=true"
import script from "./WizardSummary.vue?vue&type=script&lang=js"
export * from "./WizardSummary.vue?vue&type=script&lang=js"
import style0 from "./WizardSummary.vue?vue&type=style&index=0&id=3ab9e2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab9e2c0",
  null
  
)

export default component.exports